import { scrollbar } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { LIST_GAP, LIST_SCROLLBAR_OFFSET, SIDEBAR_PADDING } from '../config';
export const SidebarMenuBodyContainer = styled.div `
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: ${LIST_GAP};
  overflow: hidden auto;
  padding-left: ${SIDEBAR_PADDING};
  padding-right: calc(${SIDEBAR_PADDING} - ${LIST_SCROLLBAR_OFFSET});
  margin-right: ${LIST_SCROLLBAR_OFFSET};

  ${scrollbar({ trackSize: 4 })}
`;
